export const SAVE = '@tenant/SAVE';
export const FETCH = '@tenant/FETCH';
export const UPDATE = '@tenant/UPDATE';
export const REMOVE = '@tenant/REMOVE';
